import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import LinkArrow from 'src/pages/dashboard/icons/link-arrow'
import { BUNDLE_DASHBOARD , BUNDLE_SUBMISSION_DRAFT } from 'src/utils/constants/app-routes-name'
import BundleIcon from 'src/components/general/fou-navigation/icons/bundle-icon/index.vue'
import Misc from 'src/utils/helper/misc.js'
import EditIcon from 'src/pages/bundle-submission/components/icons/edit-icon/index.vue'
import AnimationProcessing from 'components/animations/processing'
import { MdButton, MdIconArrowLong } from '@antiqua-dls/vue-components'

import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'

export default {
  components: {
    LinkArrow,
    EditIcon,
    AnimationProcessing,
    BundleIcon,
    MdButton,
    MdIconArrowLong
  },
  data() {
    return {
      bundleList: [],
      showBundle: false,
      perPage: 5,
      bundleType: 'live',
      page: 1,
      defaultSortBy: 'deReleaseDate',
      sortByAsc: 'asc',
      sortDirection: 'asc',
      BUNDLE_DASHBOARD,
      BUNDLE_SUBMISSION_DRAFT
    };
  },
  computed: {
    ...mapGetters('profile', ['sessionFoundryId', 'sessionFoundryName', 'foundries']),
    currentFoundryIdValue() {
      return this.sessionFoundryId;
    },
    currentFoundryNameValue() {
      return this.sessionFoundryName;
    },
    foundriesList() {
      return this.foundries;
    },
  },
  methods: {
    updateBundleFilters() {
      return {
        type: this.bundleType,
        foundries: this.currentFoundryIdValue,
        search: '',
        page: this.page,
        perPage: this.perPage,
        sortBy: this.defaultSortBy,
        sortDirection: this.sortDirection,
        mode: '',
      };
    },
    goToBundlesPage(pageName, bundleId) {
      const routeData = {
        name: pageName,
        params: {}
      };
      if (!isEmpty(bundleId)) {
        routeData.params.id = bundleId;
      }
      this.$router.push(routeData);
    },
    goToCreateBundlesPage() {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.CREATE_BUNDLE,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: LINK_NAMES.CREATE_BUNDLE,
          linkType: LINK_TYPES.BUTTON
        }
      })
      this.$store.dispatch('bundle/createBundle', { foundries: [{ name: this.currentFoundryNameValue, id: this.currentFoundryIdValue }] })
        .then(res => {
          this.$router.push({
            name: BUNDLE_SUBMISSION_DRAFT,
            params: {
              id: res.bundle.id
            }
          });
        });
    },
    handleLearnMoreClick() {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.LEARN_MORE,
          linkSection: LINK_SECTION.BUNDLE_DASHBOARD,
          linkName: LINK_NAMES.LEARN_MORE,
          linkType: LINK_TYPES.BUTTON
        }
      })
      // Open the learn more link in a new tab
      window.open('https://foundrysupport.monotype.com/hc/en-us/articles/360028863271-Font-Bundles-FAQ', '_blank', 'noopener');
    },
    handlePermission() {
      return Misc.foundryHasModulePermission('bundles',this.foundriesList, this.currentFoundryIdValue);
    },
    getBundleList() {
      const filters = this.updateBundleFilters();
      this.showBundle = false;
      this.bundleList = [];
      if(this.handlePermission()) {
        this.$store.dispatch('bundle/getBundleList', filters).then(response => {
          this.showBundle = true;
          this.bundleList = response.collections;
        })
      } else {
        this.showBundle = true;
      } 
      return this.bundleList;
    },
    calculateDaysLeft(deReleaseDate) {
      if (!deReleaseDate) {
        return 'N/A';
      }
    
      const today = new Date();
      const releaseDate = new Date(deReleaseDate);
      const diffTime = releaseDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
      if (diffDays < 0) {
        return '0 days';
      }
    
      if (diffDays > 30) {
        const months = Math.floor(diffDays / 30);
        const days = diffDays % 30;
        return `${months} month${months > 1 ? 's' : ''} ${days} day${days > 1 ? 's' : ''}`;
      }
    
      return `${diffDays} day${diffDays > 1 ? 's' : ''}`;
    }
  },
  watch: {
    currentFoundryIdValue() {
      this.getBundleList();
    },
    currentFoundryNameValue() {
      this.getBundleList();
    }
  },
  created() {
    this.getBundleList();
  }
};
